export default "__VITE_ASSET__D7y1p_5k__"